document.addEventListener( 'DOMContentLoaded', () => {
  const
    fixedNav = document.querySelector('#fixedNav'),
    introSection = document.querySelector('main > section.intro'),
    moodSection = document.querySelector('main > section.photoMood'),
    footer = document.querySelector('body > footer'),
    featuredIssueSections = document.querySelectorAll('.buymagazine'),
    photoMoodSections = document.querySelectorAll('.photoMood'),
    quantitySelectors = document.querySelectorAll('.quantity');
    
  const introObserver = new IntersectionObserver(([entry]) => {fixedNav.classList.toggle('blue', !entry.isIntersecting);});
  if (introSection) {introObserver.observe(introSection);}
  
  const moodObserver = new IntersectionObserver(([entry]) => {fixedNav.classList.toggle('white', entry.isIntersecting);},{rootMargin: '0px 0px -70% 0px'});
  if (moodSection) {moodObserver.observe(moodSection);}
  
  const outroObserver = new IntersectionObserver(([entry]) => {fixedNav.classList.toggle('invisible', entry.isIntersecting);},{rootMargin: '0px 0px -70% 0px'});
  if (footer) {outroObserver.observe(footer);}
  
  const previewMag = (sections) => {
    sections.forEach((section) => {
      const
        figure = section.querySelector('main > figure'),
        images = figure.querySelectorAll('img');
  
      let currentIndex = 0,
          interval,
          timeout;
  
      const showImage = (index) => {
        images.forEach((img, i) => {
          img.hidden = i !== index;
        });
      };
  
      const nextImage = () => {
        currentIndex = (currentIndex + 1) % images.length;
        showImage(currentIndex);
      };
  
      // Mouse: continuous slideshow
      const start = () => {
        clearInterval(interval);
        interval = setInterval(nextImage, 400);
      };
  
      // Mouse: stop and reset
      const stop = () => {
        clearInterval(interval);
        showImage(0);
        currentIndex = 0;
      };
  
      // Touch: one complete run-through
      const tap = () => {
        clearInterval(interval);
        clearTimeout(timeout);
  
        currentIndex = 0;
        showImage(currentIndex);
  
        const advance = () => {
          currentIndex++;
  
          if (currentIndex >= images.length) {
            currentIndex = 0;
            showImage(currentIndex);
            return;
          }
  
          showImage(currentIndex);
          timeout = setTimeout(advance, 400);
        };
  
        timeout = setTimeout(advance, 400);
      };
  
      showImage(currentIndex);
  
      // Only react to actual mouse pointers
      figure.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') {
          start();
        }
      });
  
      figure.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') {
          stop();
        }
      });
  
      // Only react to actual touch pointers
      figure.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'touch') {
          tap();
        }
      });
    });
  };
  
  const photoMood = (sections) => {
    sections.forEach((section) => {
      const figures = section.querySelectorAll('main > figure');
      let currentIndex = 0, interval;
    
      const showImage = (index) => {
        figures.forEach((fig, i) => {
          fig.classList.toggle('active', i === index);
        });
      };
    
      const nextFigure = () => {
        currentIndex = (currentIndex + 1) % figures.length;
        showImage(currentIndex);
      };
    
      showImage(currentIndex);
      interval = setInterval(nextFigure, 3200);
    });
  }
    
  previewMag(featuredIssueSections);
  photoMood(photoMoodSections);
  
  if (featuredIssueSections) {
    document.querySelectorAll('.product figure > img').forEach(img => {
      const preload = new Image();
      preload.srcset = img.srcset;
      preload.sizes = img.sizes;
      preload.src = img.src;
    });
  }
    
  if (document.querySelector('body').classList.contains( 'template-cart' )) {
    quantitySelectors.forEach((quantitySelector ) => {
      const 
        input = quantitySelector.querySelector('[name="updates[]"]'),
        decreaser = quantitySelector.querySelector('.decrease'),
        increaser = quantitySelector.querySelector('.increase'),
        max = input.getAttribute('max');
  
      decreaser.addEventListener('click', () => {
        console.log('click decrease');
        if ( parseInt( input.value ) > 1 ) {
          input.value = parseInt(input.value) - 1;
        }
      } );
  
      increaser.addEventListener('click', () => {
        console.log('click increase');
        if (parseInt( input.value) < max ) {
          input.value = parseInt(input.value) + 1;
        }
      } );
    } );
  }
});
